import { useState } from 'react';
import { Alert, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ShipOrder from './ShipOrder';

const EnvioAlmacen = ({ selectedOrder, partnerOptions = [], onTransition }) => {
    const { id, shipping: { status } } = selectedOrder;
    const deliveryEligible = selectedOrder.delivery_eligible !== false;
    const shippingEligible = selectedOrder.shipping_eligible !== false;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const markAsDelivered = async () => {
        if (!window.confirm('¿Confirmas que el pedido ya fue entregado?')) return;
        setLoading(true);
        setError('');
        try {
            await onTransition(id, { action: 'deliver' });
        } catch (requestError) {
            setError(requestError.message === 'delivery_window_expired'
                ? 'El periodo de 30 días para confirmar la entrega ya venció.'
                : requestError.message === 'invalid_state'
                    ? 'El pedido cambió de estado. Actualiza la información.'
                    : 'No fue posible actualizar el pedido.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Stack spacing={2}>
            {error && <Alert severity="error">{error}</Alert>}
            {status === 'preparing' && (
                shippingEligible ? (
                    <ShipOrder selectedOrder={selectedOrder}
                        partnerOptions={partnerOptions} onTransition={onTransition} />
                ) : (
                    <Alert severity="info">
                        Periodo de envío vencido. Este pedido sólo puede consultarse.
                    </Alert>
                )
            )}
            {status === 'shipped' && (
                deliveryEligible ? (
                    <Stack direction="row" alignItems="center">
                        <LoadingButton endIcon={<CheckCircleIcon />} loading={loading}
                            loadingPosition="end" variant="contained" onClick={markAsDelivered}>
                            Marcar como entregado
                        </LoadingButton>
                        <Tooltip title={<Typography variant="caption">La acción requiere confirmación y no enviará correos duplicados.</Typography>}>
                            <IconButton><HelpOutlineIcon /></IconButton>
                        </Tooltip>
                    </Stack>
                ) : (
                    <Alert severity="info">
                        Periodo de actualización vencido. Este pedido sólo puede consultarse.
                    </Alert>
                )
            )}
            {status === 'delivered' && <Alert severity="success">Pedido entregado</Alert>}
        </Stack>
    );
};

export default EnvioAlmacen;
